var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"container loader-image-circle-for-iframe",staticStyle:{"height":"inherit"}},[_c('iframe',{attrs:{"src":_vm.iframe.src,"width":"100%","height":"100%","frameborder":"0"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }